import { connect } from "react-redux";
import Meetings from "./Meetings";
import { createMeetingRequest, updateMeetingRequest, getMeetings, cancelMeetingRequest, deleteMeetingRequest, fetchMeeting } from '../../store/actions/meetings.actions'
import { getMeeting, allMeetings, getLoading } from '../../store/selectors/meeting.selector'

const mapDispatchToProps = { getMeetings, fetchMeeting, createMeetingRequest, updateMeetingRequest, cancelMeetingRequest, deleteMeetingRequest };

const mapStateToProps = (state) => { 
    const meeting = getMeeting(state);
    const meetings = allMeetings(state);
    const loading = getLoading(state);
    return { meeting, meetings, loading };
 };

export default connect(mapStateToProps, mapDispatchToProps)(Meetings);